import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZardInputDirective } from '@shared/components/ui/input/input.directive';
import { ZardFormModule } from '@shared/components/ui/form/form.module';
import {
    FormBuilder,
    FormGroup,
    ReactiveFormsModule,
    Validators,
} from '@angular/forms';
import { Currency } from '../currencies.component';
import { TranslocoPipe } from '@ngneat/transloco';
import { Z_MODAL_DATA } from '@shared/components/ui/dialog/dialog.service';

@Component({
    selector: 'app-exchange-rate-modal',
    standalone: true,
    imports: [
        CommonModule,
        ZardFormModule,
        ZardInputDirective,
        ReactiveFormsModule,
        TranslocoPipe
    ],
    template: `
        <div class="pt-4">
            <h2 class="mb-2 justify-self-center text-lg font-semibold">
                {{ 'financial.exchange.modal.update' | transloco }}
            </h2>

            <form [formGroup]="rateForm" class="p-2">
                <div class="flex items-center justify-center space-x-4">
                    <span
                        class="font-medium text-[14px] text-gray-900 dark:text-gray-100"
                    >
                        1 {{ data.fromCurrency?.description }}
                    </span>
                    <span class="text-gray-600 dark:text-gray-300">=</span>
                    <div class="w-40">
                        <z-form-field>
                            <z-form-control>
                                <input
                                    z-input
                                    formControlName="rate"
                                    type="number"
                                    [placeholder]="'financial.exchange.enterRate' | transloco"
                                    min="0"
                                    step="0.01"
                                />
                            </z-form-control>
                        </z-form-field>
                    </div>
                    <span
                        class="font-medium text-lg text-gray-900 dark:text-gray-100"
                    >
                        {{ data.toCurrency?.description }}
                    </span>
                </div>
            </form>
        </div>
    `,
})
export class ExchangeRateModalComponent {
    rateForm: FormGroup;

    constructor(
        private fb: FormBuilder,
        @Inject(Z_MODAL_DATA)
        public data: {
            fromCurrency: Currency;
            toCurrency: Currency;
            currentRate: number;
        }
    ) {
        this.rateForm = this.fb.group({
            rate: [data.currentRate, [Validators.required, Validators.min(0)]],
        });
    }
}
